import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import ScorecardAnswersDialog from "./ScorecardAnswersDialog";
import FilterChipDisplay from "../../FilterChipDisplay";

interface IFiltersProps {
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function ScorecardAnswers({ callTableViewModel, setCallTableViewModel }: IFiltersProps) {
    const [open, setOpen] = useState(false);

    const text =
        <Typography variant="body1">
            {
                "QA Scorecard Answers - "
            }
            {
                (callTableViewModel.filters.scorecardAnswer.answer) ?
                    callTableViewModel.filters.scorecardAnswer.answer.length > 15 ?
                        callTableViewModel.filters.scorecardAnswer.answer.substring(0, 15) + "..."
                        : callTableViewModel.filters.scorecardAnswer.answer
                    : ' Is Any'
            }
        </Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setOpen(true)} />
            <ScorecardAnswersDialog
                open={open}
                setOpen={setOpen}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel}
            />
        </>
    )
}